import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import "./AuthModal.style.css";



const AuthModal = ({ open, hide, children, modalStatus, hideModal, showModal }) => {

  // if (!modalStatus) {
  //   return null;
  // }

  return (
    <Modal
      open={open}
      hide={hide}
      center
      showCloseIcon={false}
      closeOnOverlayClick={false}
      classNames={{
        overlay: "modal_overlay",
        modal: "custom-modal",
      }}
    >
      {children}
    </Modal>
  );
};

// const mapStateToProps = ({ Modal }) => ({
//   modalStatus: Modal.modal
// })


export default AuthModal
